import script from '../lib/script'

/**
 * Load and initialize the Google tag (gtag.js)
 */
export default () => {
  script('gtag', `https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GTAG}`);

  window.dataLayer = window.dataLayer || [];
  function gtag(){window.dataLayer.push(arguments);}

  gtag('js', new Date());
  gtag('config', process.env.REACT_APP_GTAG);
}
